import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'localmed-core';

import WidgetLink from '../../../shared/components/WidgetLink';

import style from './ProviderCardFooter.scss';

const ProviderCardFooter = ({ providerUrl, isOnWidget, toWidget }) => (
  <div className={style['provider-card-footer']} data-qa="provider-card__view-openings">
    <WidgetLink
      href={providerUrl}
      isOnWidget={isOnWidget}
      toWidget={toWidget}
      component={Button}
      tier="alert"
      size="sm"
    >
      View All Openings
    </WidgetLink>
  </div>
);

ProviderCardFooter.propTypes = {
  providerUrl: PropTypes.string.isRequired,
  isOnWidget: PropTypes.bool,
  toWidget: PropTypes.bool,
};

export default ProviderCardFooter;
